<template>
  <el-dialog
    :title="`Phòng ${roomData.room_num} - ${roomData.room_level_name}`"
    visible
    append-to-body
    :close-on-click-modal="false"
    width="1200px"
    @close="onClose"
  >
    <!-- <div style="display: flex; gap: 10px">
        <div
          v-for="item in Object.keys(ROOM_STATUS_TYPE_VALUE)"
          :key="ROOM_STATUS_TYPE_VALUE[item]"
        >
          <input
            :id="item"
            v-model="roomType"
            type="radio"
            :value="ROOM_STATUS_TYPE_VALUE[item]"
          />
          <label :for="item">{{ item }}</label
          ><br />
        </div>
      </div> -->
    <!-- DIALOG CONTENT -->
    <div>
      <!-- INFO SECTION -->
      <section>
        <InfoList :columns="2" class="info-list__container-custom">
          <InfoListLabel>Khách sạn</InfoListLabel>
          <InfoListValue>{{ hotelName }}</InfoListValue>
          <InfoListLabel>Tầng</InfoListLabel>
          <InfoListValue>{{ roomData.floors }}</InfoListValue>
          <!-- <InfoListLabel>Lorem ipsum</InfoListLabel>
            <InfoListValue>Lorem ipsum dolor sit amet. </InfoListValue>
            <InfoListLabel>Lorem ipsum</InfoListLabel>
            <InfoListValue>Lorem ipsum dolor sit amet. </InfoListValue> -->
        </InfoList>
      </section>
      <!-- END INFO SECTION -->
      <!-- AVAILABLE ROOM -->
      <!-- <template v-if="roomData.empty_room"> </template> -->
      <!-- BOOKED ROOM -->
      <template
        v-if="
          roomData.arrive ||
          roomData.in_house ||
          roomData.depart ||
          roomData.foc
        "
      >
        <div>
          <Tab
            v-model="tabIndex"
            class="tabmenu-container-custom"
            :tab-list="tabList"
          />
        </div>
        <!-- BOOKING INFO TAB -->
        <div v-if="tabIndex === 1" class="tab-content">
          <RoomStatusDetailReservationTab></RoomStatusDetailReservationTab>
        </div>
        <!-- CUSTOMER TAB -->
        <div v-if="tabIndex === 2" class="tab-content">
          <RoomStatusDetailCustomer></RoomStatusDetailCustomer>
        </div>
        <!-- SPECIAL SERVICE TAB -->
        <div v-if="tabIndex === 3" class="tab-content">
          <RoomStatusDetailSpecialServiceTab></RoomStatusDetailSpecialServiceTab>
        </div>
        <div v-if="tabIndex === 4" class="tab-content">
          <RoomStatusDetailChargeTab></RoomStatusDetailChargeTab>
        </div>
      </template>
      <!-- OOS ROOM -->
      <template v-if="roomData.ooo || roomData.oos">
        <div class="das-info-title m-0">
          <span v-if="roomData.ooo">Phòng ngừng sử dụng</span>
          <span v-else>Phòng không phục vụ</span>
        </div>
        <InfoList :columns="2" class="info-list__container-custom">
          <InfoListLabel>Từ ngày</InfoListLabel>
          <InfoListValue>
            {{ dateFormatter(oooOosDetail.date_from) }}
          </InfoListValue>
          <InfoListLabel>Đến ngày</InfoListLabel>
          <InfoListValue>
            {{ dateFormatter(oooOosDetail.date_from) }}
          </InfoListValue>
          <InfoListLabel>Ghi chú</InfoListLabel>
          <InfoListValue>
            {{ oooOosDetail.reason_string }}
          </InfoListValue>
        </InfoList>
      </template>
      <!-- <template v-else-if="roomData.oos">
        <div class="das-info-title m-0">Phòng không phục vụ</div>
        <InfoList :columns="2" class="info-list__container-custom">
          <InfoListLabel>Từ ngày</InfoListLabel>
          <InfoListValue>01/01/2024</InfoListValue>
          <InfoListLabel>Đến ngày</InfoListLabel>
          <InfoListValue>10/01/2024</InfoListValue>
          <InfoListLabel>Ghi chú</InfoListLabel>
          <InfoListValue>Hư cửa</InfoListValue>
        </InfoList>
      </template> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <div class="button-containers__left">
          <button
            v-if="roomData.ooo || roomData.oos"
            class="btn primary small outline"
            @click="fnCancelOOO"
          >
            Hủy OOO/OOS
          </button>
          <template v-if="!roomData.ooo">
            <button class="btn primary small" @click="fnSetRoomClean">
              Đặt phòng sạch
            </button>
            <button class="btn primary small" @click="fnSetRoomDirty">
              Đặt phòng bẩn
            </button>
            <button
              v-if="roomData.empty_room && !roomData.oos"
              class="btn primary small"
              @click="fnOpenOoDialog"
            >
              Tạo OOO/OOS
            </button>
          </template>
        </div>
        <div class="button-containers__right">
          <template v-if="roomData.empty_room">
            <!-- <button class="btn primary small" @click="onClickCreateReservation">
              Tạo đặt phòng mới
            </button>
            <button class="btn primary small" @click="onClickCreateReservation">
              Walk-in
            </button> -->
          </template>
          <template
            v-else-if="
              roomData.arrive ||
              roomData.in_house ||
              roomData.depart ||
              roomData.foc
            "
          >
            <button
              v-if="roomData.arrive && !roomData.depart"
              class="btn primary small"
              @click="fnCheckinBooking"
            >
              Check-in
            </button>
            <button
              v-if="roomData.depart"
              class="btn primary small"
              @click="onClickCheckoutBooking"
            >
              Check-out
            </button>
            <!-- <button class="btn primary small">Phiếu đăng ký</button> -->
            <!-- <button class="btn primary small">Thêm giao dịch</button> -->
            <button
              class="btn primary small"
              @click="fnOpenEditBookingRoomDialog"
            >
              Sửa đặt phòng
            </button>
          </template>
          <button class="btn primary small outline" @click="onClose">
            Hủy
          </button>
        </div>
        <CreateOooOosDialog
          v-if="addDialogVisible"
          :is-show="roomData.empty_room"
          @close="fnCloseOoDialog"
          @resetData="onCreateOoo"
        />

        <EditRoomBookingDialog
          v-if="editBookingRoomDialogVisible"
          :status-booking="bookingDetailStore.status"
          @close="fnCloseEditBookingRoomDialog"
        />
        <!-- <template v-if="roomData.empty_room">
            <div class="button-containers__left">
              <button class="btn primary small">Đặt phòng sạch</button>
              <button class="btn primary small">Đặt phòng bẩn</button>
              <button class="btn primary small">Tạo OOO</button>
            </div>
            <div class="button-containers__right">
              <button class="btn primary small">Tạo đặt phòng mới</button>
              <button class="btn primary small">Walk-in</button>
              <button class="btn primary small outline">Hủy</button>
            </div>
          </template>
          <template
            v-else-if="
              roomData.arrive ||
              roomData.in_house
            "
          >
            <div class="button-containers__left">
              <button class="btn primary small">Đặt phòng sạch</button>
              <button class="btn primary small">Đặt phòng bẩn</button>
            </div>
            <div class="button-containers__right">
              <button
                v-if="roomData.arrive"
                class="btn primary small"
              >
                Check
              </button>
              <button class="btn primary small">Phiếu đăng ký</button>
              <button class="btn primary small">Thêm giao dịch</button>
              <button class="btn primary small">Sửa đặt phòng</button>
              <button class="btn primary small outline">Hủy</button>
            </div>
          </template>
          <template v-else-if="roomData.ooo">
            <div class="button-containers__left">
              <button class="btn primary small outline">Hủy OOO</button>
            </div>
            <div class="button-containers__right">
              <button class="btn primary small outline">Hủy</button>
            </div>
          </template> -->
      </div>
    </span>
  </el-dialog>
</template>

<script>
import Tab from '@/components/Tab'
import RoomStatusDetailReservationTab from './RoomStatusDetailReservationTab.vue'
import RoomStatusDetailCustomer from './RoomStatusDetailCustomerTab.vue'
import RoomStatusDetailSpecialServiceTab from './RoomStatusDetailSpecialServiceTab.vue'
import CreateOooOosDialog from './CreateOooOosDialog.vue'
import EditRoomBookingDialog from './EditRoomBookingDialog.vue'
import RoomStatusDetailChargeTab from './RoomStatusDetailChargeTab.vue'

import { dateFormatter } from '@/utils/dataFormatter'

// API REQUEST
import {
  getRoomBookingDetailApi,
  setRoomStatusApi,
  // eslint-disable-next-line no-unused-vars
  getBookingTravellerListApi,
  checkInBookingApi
} from '@/api/chamber_service/common'

import {
  // eslint-disable-next-line no-unused-vars
  deleteOooRoomApi,
  getOooOosDetailApi
} from '@/api/houseKeeper/ooo-room'

// CONSTANT
import { ROOM_STATUS_VALUE, ROOM_BOOKING_TYPE_VALUE } from '../constants'

// STORE
import { bookingDetailStore, roomInfo, roomInfoInitialState } from '../stores/'

const getDefaultOooOosDetail = () => ({
  date_from: null,
  date_to: null,
  reason_string: null
})

export default {
  components: {
    Tab,
    RoomStatusDetailChargeTab,
    RoomStatusDetailReservationTab,
    RoomStatusDetailCustomer,
    RoomStatusDetailSpecialServiceTab,
    // eslint-disable-next-line vue/no-unused-components
    CreateOooOosDialog,
    EditRoomBookingDialog
  },
  props: {
    // roomType: {
    //   type: String
    //   // required: true
    // },
    // roomInfo: {
    //   type: Object
    //   // required: true
    // }
    hotelName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      roomType: 0,
      tabIndex: 1,
      tabList: [
        { label: 'Thông tin đặt phòng', value: 1 },
        { label: 'Khách', value: 2 },
        { label: 'Dịch vụ đặc biệt', value: 3 },
        { label: 'Phụ thu', value: 4 }
      ],
      dialogTitle: null,
      dialogLoading: false,
      addDialogVisible: false,
      editBookingRoomDialogVisible: false,
      bookingDetailStore,
      roomInfo,
      roomData: { ...roomInfoInitialState },
      oooOosDetail: getDefaultOooOosDetail()
    }
  },

  computed: {
    ROOM_BOOKING_TYPE_VALUE() {
      return ROOM_BOOKING_TYPE_VALUE
    }
  },

  watch: {
    isShow(val) {}
  },

  mounted() {
    this.roomData = this.roomInfo

    if (!this.roomData.empty_room) {
      // Promise.all([this.fnGetBookingDetail(), this.fnGetBookingTravellers()])
      this.fnGetBookingDetail()
    }
    if (this.roomData.ooo || this.roomData.oos) {
      this.fnGetOooOosDetail()
    }

    // DELETE LATER
    // this.fnGetBookingDetail()
  },
  destroyed() {
    this.roomData = { ...roomInfoInitialState }
    this.oooOosDetail = getDefaultOooOosDetail()
  },
  methods: {
    dateFormatter,
    onClose() {
      this.$emit('close')
    },

    onCreateOoo() {
      this.$emit('resetData')
      this.$emit('close')
    },

    increaseRoomTypeTest() {
      this.roomType = this.roomType === 5 ? 0 : this.roomType + 1
    },

    /** If room is not empty -> Get booking detail */
    async fnGetBookingDetail() {
      await getRoomBookingDetailApi(this.roomData.sub_booking_group_id)
        .then(res => {
          Object.assign(bookingDetailStore, res.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // async fnGetBookingTravellers() {
    //   await getBookingTravellerListApi(this.roomData.sub_booking_group_id)
    //     .then(res => {
    //       bookingDetailStore.travellers = res.data
    //       this.tabList[1].label = `${this.tabList[1].label} (${res.data.length})`
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },

    /** If room status is OOO/OOS -> Get OOO/OOS Info */
    async fnGetOooOosDetail() {
      await getOooOosDetailApi(this.roomData.ooo_oos_id)
        .then(res => {
          this.oooOosDetail = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },

    fnSetRoomClean() {
      setRoomStatusApi({
        room_status: ROOM_STATUS_VALUE.CLEAN,
        room_ids: [this.roomData.room_id]
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },

    fnSetRoomDirty() {
      setRoomStatusApi({
        room_status: ROOM_STATUS_VALUE.DIRTY,
        room_ids: [this.roomData.room_id]
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },

    fnCheckinBooking() {
      this.$vxConfirm('Xác nhận Check-in?', () => {
        checkInBookingApi([roomInfo?.sub_booking_group_id])
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('successMsg.' + res.message)
            })
            this.$emit('resetData')
            this.$emit('close')
          })
          .catch(err => {
            this.$message({
              type: 'error',
              message: this.$t('errorMsg.' + err.response.data.message)
            })
          })
      })
    },

    onClickCheckoutBooking() {
      const route = this.$router.resolve({
        path: '/cashier/post_transaction',
        query: {
          booking_id: this.roomData.sub_booking_group_id
        }
      })
      console.log(route.href, roomInfo)
      window.open(route.href, '_blank')
    },

    fnOpenOoDialog() {
      this.addDialogVisible = true
    },

    fnCloseOoDialog() {
      this.addDialogVisible = false
    },

    fnCancelOOO() {
      deleteOooRoomApi({ id_list: [this.roomData.ooo_oos_id] })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.$emit('resetData')
          this.$emit('close')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    fnOpenEditBookingRoomDialog() {
      this.editBookingRoomDialogVisible = true
    },

    fnCloseEditBookingRoomDialog() {
      this.editBookingRoomDialogVisible = false
      this.fnGetBookingDetail()
    },

    onClickCreateReservation() {
      const route = this.$router.resolve({
        path: '/reservation/new_reservation'
        // query: {
        //   id: this.roomData.room_id
        // }
      })
      window.open(route.href, '_blank')
    },

    onClickEditReservation() {
      const route = this.$router.resolve({
        path: '/reservation/new_reservation',
        query: {
          id: this.roomData.booking_code,
          action: 'edit'
        }
      })
      window.open(route.href, '_blank')
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.button-containers {
  margin-left: 20px;
  display: flex;
  gap: 20px;
  justify-content: space-between !important;

  &__left,
  &__right {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  &__left {
    align-self: left;
  }

  &__right {
    align-self: right;
    justify-content: flex-end;
  }
}

.info-list__container-custom {
  border: none;
}

.tabmenu-container-custom {
  .tab-list {
    .tab-item {
      .tab-label {
        border-bottom: 1px solid $borderColor;
      }

      &:last-child {
        border-bottom: 1px solid $borderColor;
      }

      input[type='radio']:checked ~ .tab-label {
        border: 1px solid $borderColor;
        border-bottom: none;
      }
    }
  }
}
</style>
